import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Sobre from "./pages/Sobre";
import GestaoTI from "./pages/servicos/GestaoTI";
import RMM from "./pages/servicos/RMM";
import Suporte from "./pages/servicos/Suporte";
import AcessoRemoto from "./pages/servicos/AcessoRemoto";
import Consultoria from "./pages/servicos/Consultoria";
import SepolHosting from "./pages/produtos/SepolHosting";
import SepolDrive from "./pages/produtos/SepolDrive";
import SepolBackup from "./pages/produtos/SepolBackup";
import SepolChat from "./pages/produtos/SepolChat";
import SepolSecurity from "./pages/produtos/SepolSecurity";
import OutsourcingLocacao from "./pages/produtos/Outsorcing";
import ErpBruning from "./pages/produtos/ERP";
import Faq from "./Faq";
import BaseConhecimento from "./BaseConhecimento";
import Contato from "./Contato";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";
import Cadastro from "./pages/Cadastro";
import AreaCliente from "./pages/AreaCliente";
import Painel from "./pages/Painel";
import Financeiro from "./pages/Financeiro";
import Servicos from "./pages/servicos/Servicos";
import Produtos from "./pages/produtos/Produtos";
import ScrollToHash from "./components/ScrollToHash"
import Portfolio from "./pages/Portfolio"
import HelpDeskPlans from "./HelpDeskPlans";
import AssistenciaTecnicaPlans from "./AssistenciaTecnicaPlans";
import Cases from "./Cases";
import WhatsAppWidget from "./components/WhatsAppWidget"

export default function App() {
  return (
    <BrowserRouter basename="/">
      <ScrollToHash />
      <AuthProvider>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/sobre" element={<Sobre />} />
          <Route path="/contato" element={<Contato />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/base-conhecimento" element={<BaseConhecimento />} />
          <Route path="/servicos/servicos" element={<Servicos />} />
          <Route path="/servicos/gestao-ti" element={<GestaoTI />} />
          <Route path="/servicos/rmm" element={<RMM />} />
          <Route path="/servicos/suporte" element={<Suporte />} />
          <Route path="/servicos/acesso-remoto" element={<AcessoRemoto />} />
          <Route path="/servicos/consultoria" element={<Consultoria />} />
          <Route path="/produtos/produtos" element={<Produtos />} />
          <Route path="/produtos/sepol-hosting" element={<SepolHosting />} />
          <Route path="/produtos/sepol-drive" element={<SepolDrive />} />
          <Route path="/produtos/sepol-backup" element={<SepolBackup />} />
          <Route path="/produtos/sepol-chat" element={<SepolChat />} />
          <Route path="/produtos/sepol-security" element={<SepolSecurity />} />
          <Route path="/produtos/outsourcing-locacao" element={<OutsourcingLocacao />} />
          <Route path="/produtos/erp" element={<ErpBruning />} />
          <Route path="/login" element={<Login />} />
          <Route path="/cadastro" element={<Cadastro />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/help-desk" element={<HelpDeskPlans />} />
          <Route path="/assistencia" element={<AssistenciaTecnicaPlans />} />
          <Route path="/cases" element={<Cases />} />

          {/* Rotas protegidas — só acessíveis com sessão ativa */}
          <Route element={<ProtectedRoute />}>
            <Route path="/area-cliente" element={<AreaCliente />} />
            <Route path="/painel" element={<Painel />} />
            <Route path="/financeiro" element={<Financeiro />} />
          </Route>
        </Routes>
        <Footer />
      </AuthProvider>
      <WhatsAppWidget/>
    </BrowserRouter>
  );
}
